import { useQuery } from '@tanstack/react-query';
import { fetchShipmentCargoTypesPricingList } from '../../data-provider/select-options';

export const useGetShipmentCargoTypesPricing = () => {
  return useQuery({
    queryKey: ['shipment-cargo-types-pricing-list'],
    queryFn: () => fetchShipmentCargoTypesPricingList(),
    staleTime: 1000 * 60 * 60, // 1 hour
  });
};
